import {
  Button,
  Box,
  Stack,
  List,
  FormControl,
  FormControlLabel,
  Switch,
  Typography,
  useTheme,
} from "@mui/material";
// import { useEffect } from "react";
import { useAuth } from "~contexts/Auth";
import { ROUTES, ROLES } from "~routes/constants";
import { LogoutIcon, UsersIcon } from "../../Icons/NavigationMenuIcons";
import { useLocation, useNavigate } from "react-router-dom";
import { ListItemLink, Logo } from "~components/atoms";
import { InfoIcon } from "~components/Icons/index";
import { useStreamContext } from "~contexts/Stream";
import { useSocketContext } from "~contexts/Socket";
// import useCronJob from "../../../hooks/useCronJob";
// import { useToastNotificationContext } from "~contexts/ToastNotification";

const NavigationMenu: React.FC = () => {
  const theme: any = useTheme();
  const { Logout, user, hasPermission, getAvailableStreams } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { stream, updateStream, currentStream } = useStreamContext();
  const { updateStreamSocket } = useSocketContext();
  // const { setToastData } = useToastNotificationContext();

  // const { desativarCronJobs, responseApi, setResponse } = useCronJob();

  // const toastMessagesCron = {
  //   success: {
  //     title: "Desativado",
  //     text: "Reenvio automático  da planilha foi desativado com sucesso",
  //   },
  //   error: {
  //     title: "falha na requisição",
  //     text: "Problemas na  atualização da planilha ",
  //   },
  // };

  // useEffect(() => {
  //   if (responseApi === "desabled") {
  //     setToastData(toastMessagesCron.success, "success");
  //     setResponse("");
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [responseApi]);

  const toggleLive = async () => {
    if (!stream) return;

    const data = {
      is_live: +!stream.is_live,
      has_chat: stream.has_chat,
      has_reaction: stream.has_reaction,
      has_measure: stream.has_measure,
      sales_channel: stream.sales_channel,
      video_url: stream.video.url,
      vimeo_id: stream.video.vimeo_id,
      is_rerun: stream.video.isRerun,
      rerun_start_time: stream.video.rerunStartTime,
    };

    try {
      await updateStream(data);
      updateStreamSocket(data);
    } catch (error) {
      console.error("Error toggling live entry:", error);
    }
  };

  if (location.pathname === "/chat") {
    return null;
  }

  return (
    <Box
      sx={{
        width: 279,
        backgroundColor: theme.palette.grey[700],
        m: 2.5,
        py: 5,
        px: 5.5,
        borderRadius: 8,
        display: "flex",
        flexDirection: "column",
        position: "initial",
        flexShrink: 0,
      }}
    >
      <Stack
        direction="column"
        justifyContent="stretch"
        alignItems="center"
        sx={{ flex: "1" }}
      >
        <Logo />

        <List sx={{ width: "100%" }}>
          {ROUTES.filter((item) => {
            // Se não há stream selecionada, mostrar apenas a home
            if (!currentStream) {
              return item.to === "/home";
            }

            // Admin vê todas as rotas
            if (user?.role === ROLES.admin) return true;
            // Chat vê apenas rotas de chat
            if (user?.role === ROLES.chat) return item.roles.includes(ROLES.chat);
            // Usuario vê apenas rotas que tem permissão em QUALQUER stream (não apenas a stream atual)
            if (user?.role === ROLES.usuario && item.screen) {
              // Home sempre permitida
              if (item.screen === 'home') return true;

              // Verificar se tem permissão para essa screen em QUALQUER stream disponível
              const availableStreams = getAvailableStreams();
              return availableStreams.some((stream) => hasPermission(stream.id_stream, item.screen));
            }
            return false;
          }).map((item, index) => {
            if (item.to === "/home") {
              return null;
            }
            return (
              <ListItemLink
                to={item.to}
                icon={item.icon}
                primary={item.primary}
                key={index}
              />
            );
          })}
        </List>
        <Box sx={{ marginTop: "5px", marginBottom: "8px", width: "100%" }}>
          {currentStream && (
            <>
              {stream?.id_stream && hasPermission(stream.id_stream, 'stream') && (
                <>
                  <FormControl>
                    <FormControlLabel
                      control={<Switch name="chat" sx={{ marginLeft: "45px" }} />}
                      checked={Boolean(stream?.is_live)}
                      onChange={toggleLive}
                      label="ativar entrada "
                      labelPlacement="start"
                    />
                  </FormControl>
                  <Typography
                    color={theme.palette.grey[400]}
                    variant="caption"
                    sx={{ display: "flex", my: 1, marginBottom: "32px" }}
                  >
                    <InfoIcon sx={{ color: "transparent", mr: 0.5 }} />a entrada da live está{" "}
                    {stream?.is_live ? "HABILITADA" : "desabilitada"} nesse momento
                  </Typography>
                </>
              )}

              {/* <Button
                onClick={desativarCronJobs}
                variant={"refreshButton"}
                style={{ width: "204px", height: "48px" }}
              >
                desativar subida automática
              </Button> */}
            </>
          )}

          <hr style={{ width: "100%" }} />

          {user?.role === ROLES.admin && (
            <Button
              type="button"
              variant="text"
              onClick={() => navigate("/usuarios")}
              startIcon={<UsersIcon sx={{ color: "transparent" }} />}
              disableFocusRipple
              disableRipple
              sx={{
                mt: currentStream ? 3 : 0,
                '& .MuiButton-startIcon': {
                  marginRight: '8px',
                  marginLeft: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '24px !important',
                  height: '24px !important',
                  fontSize: '24px !important',
                  '& > svg': {
                    width: '24px !important',
                    height: '24px !important',
                    fontSize: '24px !important',
                  }
                }
              }}
            >
              usuários
            </Button>
          )}

          <Button
            type="submit"
            variant="text"
            onClick={Logout}
            startIcon={<LogoutIcon sx={{ color: "transparent" }} />}
            disableFocusRipple
            disableRipple
            sx={{
              mt:
                user?.role === ROLES.admin && currentStream
                  ? 1
                  : user?.role === ROLES.admin
                    ? 3
                    : currentStream
                      ? 3
                      : 0,
              '& .MuiButton-startIcon': {
                marginRight: '8px',
                marginLeft: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '24px !important',
                height: '24px !important',
                fontSize: '24px !important',
                '& > svg': {
                  width: '24px !important',
                  height: '24px !important',
                  fontSize: '24px !important',
                }
              }
            }}
          >
            sair da conta
          </Button>
        </Box>
      </Stack>
    </Box>
  );
};

export default NavigationMenu;
